import { twMerge } from "tailwind-merge";

import {
  PATIENT_LIST_PROVIDER_FILTERS,
  PatientListProviderFilters,
} from "../utils";

interface FilterPatientsButtonProps {
  filter: PatientListProviderFilters;
  disabled?: boolean;
  onFilterChanged: (value: PatientListProviderFilters) => void;
}
export const FilterOwnPatientsButton = ({
  filter,
  disabled = false,
  onFilterChanged,
}: FilterPatientsButtonProps) => {
  return (
    <div className={twMerge(disabled && "opacity-50")}>
      <button
        disabled={disabled}
        className={twMerge(
          "rounded-l-lg border border-r-0 border-gray-200 p-3 text-gray-700",
          filter === PATIENT_LIST_PROVIDER_FILTERS.all &&
            "border-r border-blue-600 bg-blue-100 font-medium text-blue-600",
          filter != PATIENT_LIST_PROVIDER_FILTERS.all && "hover:bg-neutral-150",
        )}
        onClick={() => onFilterChanged(PATIENT_LIST_PROVIDER_FILTERS.all)}
      >
        All
      </button>
      <button
        disabled={disabled}
        className={twMerge(
          "rounded-r-lg border border-gray-200 p-3 text-gray-700",
          filter === PATIENT_LIST_PROVIDER_FILTERS.me &&
            "border-l border-blue-600 bg-blue-100 font-medium text-blue-600",
          filter != PATIENT_LIST_PROVIDER_FILTERS.me && "hover:bg-neutral-150",
        )}
        onClick={() => onFilterChanged(PATIENT_LIST_PROVIDER_FILTERS.me)}
      >
        My patients
      </button>
    </div>
  );
};
